module.exports = __webpack_public_path__ + "static/img/ikona_cw5-OFF.8faf1bb9.png";